import { loopbackRequestCreator } from 'redux-rest-helper-for-loopback';
import { Greetings } from '../classes/Greetings';
import apis from '../configs/apis';

export const greetingsRequest = loopbackRequestCreator<Greetings>(apis.GREETINGS);
